import { createReportEditStore } from '@/stores/report-edit/create-report-edit-store';

export type { LocalEdit, NewItem } from '@/stores/report-edit/create-report-edit-store';

export const useAvailabilityReportStore = createReportEditStore({
  name: 'availability-report-store',
});
